import React, { Component } from "react";
import { withCookies, Cookies } from "react-cookie";
import { instanceOf } from "prop-types";
import { withRouter } from "react-router-dom";
import { NotificationManager } from "react-notifications";

// Services
import ordersService from "@services/orders";

// Components
import Menu from "@components/Menu";
import PDFPrint from "@components/PdfPrint";
import DocumentPrintModal from "@components/DocumentPrintModal";
import { EventBus as eventBus } from "@components/EventBus";
import paymentsService from "@services/payments";
import { hideGlobalLoading } from "@services/axiosInstance";
import {
  MdArrowBack,
  MdPrint,
  MdReceipt,
  MdPerson,
  MdPayment,
  MdAccessTime,
  MdNote,
} from "react-icons/md";
import ClipLoader from "react-spinners/ClipLoader";

import UserContext from "@components/context/userContext";
import { TimestampToDate } from '@utils/date';
import { twoDecimal } from '@utils/format';

import '../sales/view.css';
import './view.css';

const paymentMethods = [
  {
    value: 1,
    label: "Dinheiro"
  },
  {
    value: 2,
    label: "Crédito"
  },
  {
    value: 3,
    label: "Cheque"
  },
  {
    value: 4,
    label: "TPA"
  },
  {
    value: 16,
    label: "Nota de Crédito"
  },
  {
    value: 104,
    label: "Transferência"
  },
];

class Page extends Component {
  static contextType = UserContext;

  static propTypes = {
    cookies: instanceOf(Cookies).isRequired,
  };

  constructor(props) {
    super(props);

    const {
      match: { params },
    } = this.props;

    this.state = {
      loaded: false,
      recibo: null,
      provider: null,
      orders: [],
      loading: true,
      previewUrl: null,
    };

    this.numero = params.numero;
    this.loadFunction = this.loadFunction.bind(this);
    this.handleGoBack = this.handleGoBack.bind(this);
    this.handlePrint = this.handlePrint.bind(this);
    this.openPrintModal = this.openPrintModal.bind(this);
    this.printerRef = React.createRef();
  }

  async loadFunction() {
    if (!this.state.loaded) {
      const idempresa = this.props.cookies.get("member_idempresa");

      try {
        // Carregar recibo pelo número
        const recibo = await ordersService.getPaymentByNumero(idempresa, this.numero);

        if (!recibo) {
          NotificationManager.error("Recibo não encontrado", "Erro", 3000);
          this.props.history.push("/payments");
          return;
        }

        // Carregar linhas (orders) do recibo
        // O backend retorna as linhas no campo 'lines'
        let orders = [];
        if (recibo.lines && Array.isArray(recibo.lines)) {
          orders = recibo.lines.map(line => ({
            ...line,
            doc: line.numero_documento || '-',
            data: line.data_documento || '-',
            valor: parseFloat(line.valor || 0),
            valor_inicial: parseFloat(line.valor_inicial || 0),
            valor_liquido: parseFloat(line.valor_liquido || 0),
          }));
        }

        // Corrigir conversão de data - date_time já vem em segundos
        const dateTime = typeof recibo.date_time === 'string' ? parseInt(recibo.date_time, 10) : recibo.date_time;
        const formattedDate = dateTime ? TimestampToDate(dateTime) : '';

        this.setState({
          recibo: {
            ...recibo,
            formattedDate,
          },
          orders,
          loaded: true,
          loading: false,
        });
      } catch (error) {
        console.error('Erro ao carregar recibo:', error);
        NotificationManager.error("Erro ao carregar recibo", "Erro", 3000);
        this.setState({ loading: false });
      }
    }
  }

  handleGoBack() {
    if (window.history.length > 1) {
      this.props.history.goBack();
    } else {
      this.props.history.push("/payments");
    }
  }

  async handlePrint() {
    // Este método será chamado pelo modal com opções selecionadas
    // Mantido por compatibilidade se for necessário trigger direto
    this.openPrintModal();
  }

  openPrintModal() {
    setTimeout(() => {
      eventBus.$emit("Modal-document-print", { header: null, body: null, isOpen: true });
    }, 10);
  }

  render() {
    const { location, history } = this.props;
    const { recibo, orders, loaded, loading } = this.state;
    
    // Calcular totais das linhas - soma do valor_liquido de todas as linhas
    const totalValorLiquido = orders.reduce((sum, order) => sum + parseFloat(order.valor_liquido || 0), 0);

    if (!loaded || loading) {
      return (
        <div>
          <Menu
            loadFunction={this.loadFunction}
            location={location}
            history={history}
          />
          <div className="fullContainer">
            <div className="col-xs-12" style={{ textAlign: "center", paddingTop: "100px" }}>
              <ClipLoader color="#007bff" loading={true} size={50} />
            </div>
          </div>
        </div>
      );
    }

    if (!recibo) {
      return (
        <div>
          <Menu
            loadFunction={this.loadFunction}
            location={location}
            history={history}
          />
          <div className="container">
            <div className="alert alert-warning">Recibo não encontrado</div>
          </div>
        </div>
      );
    }

    const paymentMethod = paymentMethods.find(p => p.value === parseInt(recibo.forma_pagamento || 1));
    const dateTime = typeof recibo.date_time === 'string' ? parseInt(recibo.date_time, 10) : recibo.date_time;
    const displayDate = dateTime ? new Date(dateTime * 1000).toLocaleString('pt-PT', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit'
    }) : '';

    return (
      <>
      <div>
        <Menu
          loadFunction={this.loadFunction}
          location={location}
          history={history}
        />
        <div className="fullContainer" style={{ maxWidth: '100%', backgroundColor: '#262626' }}>
          <div className="col-xs-12">
            <ol
              style={{
                textAlign: 'left',
                marginTop: '75px',
              }}
              className="breadcrumb"
            >
              <li>
                <a href="http://eposgestofinal.com/index.php">Portal</a>
              </li>
              <li>
                <button 
                  type="button"
                  onClick={this.handleGoBack}
                  style={{ background: 'none', border: 'none', padding: 0, color: '#337ab7', cursor: 'pointer', textDecoration: 'none' }}
                  onMouseEnter={(e) => e.target.style.textDecoration = 'underline'}
                  onMouseLeave={(e) => e.target.style.textDecoration = 'none'}
                >
                  Pagamentos
                </button>
              </li>
              <li className="active">
                <span>Detalhes do Recibo {recibo.numero}</span>
              </li>
            </ol>
          </div>
        </div>

        <div className="invoice-container">
          {/* Header Bar */}
          <div className="header-bar" style={{ backgroundColor: '#262626' }}>
            <div className="header-content">
              <button className="btn-back" onClick={this.handleGoBack}>
                <MdArrowBack size={20} /> <span>Voltar</span>
              </button>
              <div className="document-info">
                <MdReceipt size={24} />
                <div>
                  <h1>REC-{recibo.numero}</h1>
                  <p>{displayDate}</p>
                </div>
              </div>
              <div className="header-actions">
                <button className="btn-action" onClick={this.openPrintModal}>
                  <MdPrint size={18} /> <span>Imprimir</span>
                </button>
              </div>
            </div>
          </div>

          <div className="content-wrapper">
            {/* Main Content */}
            <div className="invoice-content">
              {/* Provider and Payment Info */}
              <div className="info-cards-container">
                {recibo.nif && (
                  <div className="info-card client-card">
                    <div className="card-header">
                      <MdPerson size={20} />
                      <h2>Informação do Fornecedor</h2>
                    </div>
                    <div className="card-content">
                      <h3>{recibo.nome_1 || '-'}</h3>
                      {recibo.nif && recibo.nif !== '999999990' && (
                        <div className="detail-item">
                          <span>NIF: {recibo.nif}</span>
                        </div>
                      )}
                      {recibo.morada_1 && (
                        <div className="detail-item">
                          <span style={{ whiteSpace: 'pre-line' }}>
                            {recibo.morada_1}
                          </span>
                        </div>
                      )}
                      {(recibo.codigo_postal || recibo.localidade_postal) && (
                        <div className="detail-item">
                          <span>
                            {recibo.codigo_postal || ''} {recibo.localidade_postal || ''}
                          </span>
                        </div>
                      )}
                    </div>
                  </div>
                )}

                <div className="info-card payment-card">
                  <div className="card-header">
                    <MdPayment size={20} />
                    <h2>Detalhes de Pagamento</h2>
                  </div>
                  <div className="card-content">
                    <div className="detail-item">
                      <MdAccessTime size={16} />
                      <span>
                        <strong>Data e Hora:</strong> {displayDate}
                      </span>
                    </div>
                    <div className="detail-item">
                      <MdPayment size={16} />
                      <span>
                        <strong>Método:</strong> {paymentMethod?.label || '-'}
                      </span>
                    </div>
                    {recibo.forma_pagamento === '3' && (
                      <>
                        {recibo.numero_cheque && (
                          <div className="detail-item">
                            <span>
                              <strong>Número do Cheque:</strong> {recibo.numero_cheque}
                            </span>
                          </div>
                        )}
                        {recibo.banco && (
                          <div className="detail-item">
                            <span>
                              <strong>Banco:</strong> {recibo.banco}
                            </span>
                          </div>
                        )}
                        {recibo.data_pre_datado && (
                          <div className="detail-item">
                            <span>
                              <strong>Data Pré-datado:</strong> {recibo.data_pre_datado}
                            </span>
                          </div>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>

              {/* Document Observations */}
              {recibo.obs && (
                <div className="observations-section">
                  <div className="section-header">
                    <MdNote size={24} />
                    <h2>Observações do Documento</h2>
                  </div>
                  <div className="observations-content">
                    <p>{recibo.obs}</p>
                  </div>
                </div>
              )}

              {/* Orders Table (if available) */}
              {orders.length > 0 && (
                <div className="products-section">
                  <div className="section-header">
                    <h2>Orders Liquidadas</h2>
                  </div>
                  <div className="table-container">
                    <table className="products-table">
                      <thead>
                        <tr>
                          <th>Número Documento</th>
                          <th>Data Documento</th>
                          <th className="text-end">Valor Inicial</th>
                          <th className="text-end">Valor Liquidado</th>
                        </tr>
                      </thead>
                      <tbody>
                        {orders.map((order, index) => (
                          <tr key={index}>
                            <td>{order.doc || '-'}</td>
                            <td>{order.data || '-'}</td>
                            <td className="text-end">{twoDecimal(order.valor_inicial || 0)} €</td>
                            <td className="text-end">{twoDecimal(order.valor_liquido || 0)} €</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {/* Totals */}
              <div className="totals-section">
                <div className="totals-card">
                  <div className="totals-row">
                    <span>Valor Liquidado</span>
                    <span>{twoDecimal(orders.length > 0 ? totalValorLiquido : (recibo.valor_iliquido || 0))} €</span>
                  </div>
                  {parseFloat(recibo.valor_desc_recibo || 0) > 0 && (
                    <div className="totals-row">
                      <span>Desconto no Recibo</span>
                      <span>-{twoDecimal(recibo.valor_desc_recibo || 0)} €</span>
                    </div>
                  )}
                  <div className="totals-row total">
                    <span>Total</span>
                    <span>{twoDecimal(recibo.valor_liquido || 0)} €</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <PDFPrint ref={this.printerRef} pdfUrl={this.state.previewUrl || ''} />
      <DocumentPrintModal
        onPrint={async ({ selectedPageSize }) => {
          const idempresa = this.props.cookies.get("member_idempresa");
          const numero = this.state.recibo?.numero;
          if (!idempresa || !numero) return;
          const url = paymentsService.getPrintUrl(idempresa, numero, selectedPageSize);
          try {
            await this.setState({ previewUrl: url });
            if (this.printerRef?.current && typeof this.printerRef.current.handlePrint === 'function') {
              await this.printerRef.current.handlePrint();
            }
          } finally {
            // Garantir que o loading global é escondido como em sales
            hideGlobalLoading();
          }
        }}
        showPageTypes={false}
        defaultPageSize="a4"
        customTitle="Imprimir Recibo"
      />
    </>
    );
  }
}

export default withCookies(withRouter(Page));
